import { gql } from "apollo-boost";

const findDivision = gql`
  {
    findDivision {
      id
      name
      directorId
      director {
        id
        name
      }
      regionId
      zoneId
      region {
        id
        name
      }
      createDate
      communities {
        id
        name
      }
    }
  }
`;

const saveDivision = gql`
  mutation saveDivision($input: SaveDivisionInput!) {
    saveDivision(input: $input)
  }
`;

export const divisionGql = {
  findDivision,
  saveDivision,
};
